export type ComNavSize = 'desktop' | 'mobile'
